
namespace TabAurous.ECommerce { 
    @Serenity.Decorators.registerClass()
    export class ECommOrderItemsSelectGrid extends _Ext.GridBase<ECommOrderItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderItems'; } 
        protected getIdProperty() { return ECommOrderItemsRow.idProperty; } 
        protected getLocalTextPrefix() { return ECommOrderItemsRow.localTextPrefix; }
        protected getService() { return ECommOrderItemsForInvoiceService.baseUrl; }

        private autoSize;
        private pendingChanges: Q.Dictionary<any> = {}; 
      
        constructor(container: JQuery,options) {
            super(container, options);

            var request = this.view.params as ReportFiltersRequest;
            var poscustomerid = options.GridFilters.CustomerId;
            if (poscustomerid != undefined && poscustomerid > 0) {
                (this.view.params as TransactionRequest).PartyId = poscustomerid;
                (this.view.params as TransactionRequest).InStock= true;
                //(this.view.params as TransactionRequest).InStock = ECommOrderItemsSelectGrid.InStock;
            } 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        get selectedItems(): ECommOrderItemsRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        } 
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 100;
            return opt;
        }
    } 
}